import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND_LOGO, BRAND_LOGO_ALT } from '../config/brand';

/**
 * Brand logo wrapped in a Link to "/".
 * Use `size` ("sm" | "md" | "lg") to scale.
 * Use `variant` "default" (logo as-is) | "white" (force white text via filter — for dark hero overlays).
 */
const BrandLogo = ({ size = 'md', variant = 'default', className = '', linkTo = '/' }) => {
  const heights = {
    sm: 'h-10 md:h-12',
    md: 'h-12 md:h-14',
    lg: 'h-16 md:h-24',
    xl: 'h-20 md:h-28 lg:h-32',
  };
  const filter = variant === 'white'
    ? { filter: 'brightness(0) invert(1)' }       // make logo solid white on dark backgrounds
    : undefined;

  return (
    <Link to={linkTo} aria-label="AI School for All" data-testid="brand-logo" className={`inline-flex items-center ${className}`}>
      <img
        src={BRAND_LOGO}
        alt={BRAND_LOGO_ALT}
        style={filter}
        className={`${heights[size] || heights.md} w-auto object-contain select-none`}
        draggable={false} decoding="async" fetchPriority="high" loading="eager" />
    </Link>
  );
};

export default BrandLogo;
